
import config from '../../../config'

import { ModelCard } from '../../../components/Model'

const MoreFrom = ({ isLoading, moreFrom }) => {

    return (
        <>
            {!isLoading && moreFrom.length > 0 &&
                <div className="container col-xl-10 px-4 py-5" id="more">
                    <p className="col-lg-10 fs-4 text-white text-truncate">More From Creator</p>
                    <hr className="solid" />

                    <div className='col-lg-12 mx-auto' >
                        <div className='row d-flex'>
                            {
                                moreFrom.map(data => {
                                    return (
                                        <ModelCard
                                            name={data.name}
                                            image={data.image}
                                            slugUrl={data.slug_url}
                                            createdAt={data.created_at}
                                            key={data.id}
                                        />
                                    )
                                })
                            }
                        </div>
                    </div>

                </div>
            }
        </>

    )
}

export default MoreFrom